import { deleteApi, getApi, putApi } from "../../common/api";

export const listEnquiries = (params: string = "") => {
    return getApi('/api/enquiries', params);
};

export const updateEnquiryStatus = (id: string, status: string) => {
    return putApi(`/api/enquiries/${id}`, { status });
};

export const deleteEnquiry = (id: string) => {
    return deleteApi(`/api/enquiries/${id}`);
};
